/*eslint-disable*/
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Lucky from "./component/Lucky";
import LuckyDetail from "./component/LuckyDetail";
import LuckHist from "./component/LuckHist";
import ContactPage from "./component/ContactPage";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Lucky />} />
                <Route path="/luckyDetail" element={<LuckyDetail />} />
                <Route path="/940729010567859400518" element={<LuckHist />} />
                <Route path="/contact" element={<ContactPage />} />
            </Routes>
        </Router>
    );
}

export default App;
